import { useContext, useEffect, useState } from "react";
import { MyContext } from "../../globalContext";
import { fetchContentFromAzureBlobStorage } from "../../data/Contentapi";

export const useTelemedicine = () => {
  const [telmedicinepdf, setTelemedicinepdf] = useState("");
  const { languageData } = useContext(MyContext);

  useEffect(() => {
    (async () => {
      try {
        const content = await fetchContentFromAzureBlobStorage(
          languageData.toLowerCase(),
          "Documents",
          languageData == "en"
            ? "TELEMED_MODALITIES.pdf"
            : " SP_TELEMED_MODALITIESNEW.pdf"
        );
        setTelemedicinepdf(content.contentData);
      } catch (e) {
        console.log(e.message);
      }
    })();
  },[]);

  return telmedicinepdf;
};
